import script from "./CountdownOverlay.vue?vue&type=script&setup=true&lang=js"
export * from "./CountdownOverlay.vue?vue&type=script&setup=true&lang=js"

import "./CountdownOverlay.vue?vue&type=style&index=0&id=65b62b34&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-65b62b34"]])

export default __exports__